/**
 * Short relative label for list UIs (e.g. "2 hours ago"). Falls back to a short date
 * when the entry is older than ~7 days or the timestamp is in the future (clock skew).
 */
export function formatRelativeAge(locale: string, nowMs: number, timestampMs: number): string {
  if (!Number.isFinite(timestampMs) || timestampMs <= 0) return '';

  const diffMs = nowMs - timestampMs;
  if (diffMs < -60_000) {
    return new Date(timestampMs).toLocaleDateString(locale, { month: 'short', day: 'numeric', year: 'numeric' });
  }

  const diffSec = Math.max(0, Math.floor(diffMs / 1000));
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
  if (diffSec < 45) return rtf.format(-diffSec, 'second');
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return rtf.format(-diffMin, 'minute');
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return rtf.format(-diffHr, 'hour');
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay < 7) return rtf.format(-diffDay, 'day');
  return new Date(timestampMs).toLocaleDateString(locale, { month: 'short', day: 'numeric', year: 'numeric' });
}
